import StartupsInstance from 'modules/startups/repository';

export function fetchStartups(page, size, search) {
  return StartupsInstance.getStartupsSearcher({ page, size, search });
}
